import React from "react";
import _ from "lodash";
import Axios from "Source/axiosPool";

class Name extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onChecking", "onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });

        this.inputRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if(!_.isEqual(nextProps.value, this.props.value) && nextProps.value === null) {
            this.inputRef.current.value = null;
        }

        if(!_.isEqual(nextProps.isUpdated, this.props.isUpdated) && nextProps.isUpdated) {
            this.inputRef.current.value = nextProps.value;
            this.onChange(nextProps.value, nextProps.workstreamId, nextProps.projectId);
        }

        return true;
    }

    onChecking( e, workstreamId, projectId ) {
        Axios.get(`api/workstream/checkName`, { name: e, id: workstreamId, projectId })
            .then(res=>{
                if( res ) {
                    if( this.props.onChange ) {
                        this.props.onChange({ target: { id: "name", value: e }, error: false });
                    }
                }
            })
            .catch(response => {
                if( response ) {
                    if( this.props.onChange ) {
                        this.props.onChange({ target: { id: "name", value: e }, error: true });
                    }
                }
            })
    }

    onChange(e, workstreamId, projectId) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "name", value: e }, error: false });
        }

        this.onChecking(e, workstreamId, projectId)
    }

    render() {
        const { setWorkstreamNameTouched } = this.props;
        const debounced = _.debounce(value => this.onChange(value, this.props.workstreamId, this.props.projectId), 400);
        
        return (
            <React.Fragment>
                <input defaultValue={this.props.value} ref={this.inputRef} type="text" 
                    placeholder="Type here" 
                    class={`${this.props.error ? "hasError" : ""}`} 
                    onChange={e => debounced(e.target.value)}
                    onKeyDown={() => setWorkstreamNameTouched(true)}
                />
                {this.props.error && <span class="errorMsg">Workstream name already taken!</span>}
            </React.Fragment>
        );
    }
}

export default Name;
